import React, { Component } from 'react';
import { Provider } from 'mobx-react';
import { BrowserRouter, Route } from 'react-router-dom';
import ConfirmPromptState from './state/ConfirmPrompt';

import { Container } from 'ui/components';

import {
	HomePage,
	OrderStatusPage,
	OrderDetailsPage,
	ItemSearchPage,
	ProductGroupPage,
	SearchPartNumberPage,
	ItemDetailsItemPage,
	ItemDetailsPackPage,
	OfferingsPage,
	CartPage,
	HelpPage,
} from 'ui/pages';

/**
 *  Load application stores
 */
import * as states from './state';

function getUserConfirmation(message, cb) {
	ConfirmPromptState.showPrompt(message, cb);
}

export default class App extends Component {
	render() {
		return (
			<Provider {...states}>
				<BrowserRouter getUserConfirmation={getUserConfirmation}>
					<Container>
						<Route exact path="/" component={HomePage} />
						<Route exact path="/search" component={ItemSearchPage} />
						<Route
							exact
							path="/view-order-history"
							component={OrderStatusPage}
						/>
						<Route
							exact
							path="/view-order-history/search-part-number"
							component={SearchPartNumberPage}
						/>

						<Route
							exact
							path="/order-history/:OrderNumber"
							component={OrderDetailsPage}
						/>

						<Route
							exact
							path="/product-group/:GroupCodeDescription"
							component={ProductGroupPage}
						/>

						<Route exact path="/details/item" component={ItemDetailsItemPage} />
						<Route exact path="/details/pack" component={ItemDetailsPackPage} />
						<Route exact path="/offerings" component={OfferingsPage} />
						<Route exact path="/cart" component={CartPage} />
						<Route exact path="/help" component={HelpPage} />
					</Container>
				</BrowserRouter>
			</Provider>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App.js